import React from 'react';
import { View, StyleSheet, useWindowDimensions, StyleProp, ViewStyle } from 'react-native';
import { studentTheme } from '../../theme/tokens';

interface StageCardProps {
    children: React.ReactNode;
    style?: StyleProp<ViewStyle>;
    contentContainerStyle?: StyleProp<ViewStyle>;
    testID?: string;
}

/**
 * StageCard — The central floating canvas island.
 * Provides high contrast, an uncluttered cognitive haven, and a rounded tactile border.
 */
export const StageCard: React.FC<StageCardProps> = ({
    children,
    style,
    contentContainerStyle,
    testID = 'stage-card',
}) => {
    const { width } = useWindowDimensions();
    const isTablet = width >= 768;
    const isSmallMobile = width < 600;

    return (
        <View
            testID={testID}
            style={[
                styles.container,
                {
                    borderRadius: isTablet ? studentTheme.radii.stageCard : studentTheme.radii.stageCardMobile,
                },
                style,
            ]}
        >
            <View style={[styles.innerContent, isSmallMobile && styles.innerContentMobile, contentContainerStyle]}>
                {children}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        backgroundColor: studentTheme.colors.stage.background,
        borderWidth: 2,
        borderColor: studentTheme.colors.stage.border,
        // Tactile depth / multi-layered ambient shadow
        shadowColor: '#0F172A',
        shadowOffset: { width: 0, height: 10 },
        shadowOpacity: 0.12,
        shadowRadius: 20,
        elevation: 10,
        width: '100%',
        maxWidth: 840,
        alignSelf: 'center',
        overflow: 'hidden',
    },
    innerContent: {
        padding: 24,
    },
    innerContentMobile: {
        padding: 16,
    },
});
